module.exports = __webpack_public_path__ + "static/media/img5.a35e55e9.jpg";